const moment = require('moment-timezone')


export const convertToTimezone = (time, timezone = 'Australia/Sydney', format = 'MMMM Do YYYY, h:mm A') => {
    // Default to current UTC time if none provided
    if (!time) time = moment.utc();

    return moment.tz(time, timezone).format(format);

}